import React, { createContext, useState } from 'react';
import { useSearchContent } from '../helpers/SearchContentBuilder';

const initialContext = {
    JsSearch: () => { },
    setSearchText: () => { },
    searchText: ''
}

export const SearchContext = createContext(initialContext);

export const SearchProvider = ({ children }) => {
    const [searchText, setSearchText] = useState('');
    const JsSearch = useSearchContent();
    return (
        <SearchContext.Provider
            value={{
                JsSearch,
                searchText,
                setSearchText,
            }}
        >
            {children}
        </SearchContext.Provider>
    )
}

export default SearchProvider;

export const withSearch = (BaseComponent) => (props) => {
    return (
        <SearchContext.Consumer>
            {context => (
                <BaseComponent
                    {...props}
                    search={{
                        JsSearch: context.JsSearch,
                        searchText: context.searchText,
                        setSearchText: context.setSearchText,
                    }}
                />
            )}
        </SearchContext.Consumer>
    )
}